// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"7a015e39","453":"6ce21281"}[chunkId] + ".chunk.js";
};